import React, { useState, useEffect } from 'react';
import { JitsiMeeting } from '@jitsi/react-sdk';
import {useLocation} from 'react-router-dom';

import { axiosInstance } from '../lib/axiosInstance';

function VideoCall() {
  const { state } = useLocation();
  const userId = state?.userId;   // user id passed from UpcomingSessionPanel
  const sessionId = state?.sessionId; // session id passed from UpcomingSessionPanel

  const [token, setToken] = useState(null);

  const appId = process.env.REACT_APP_JITSI_APP_ID ;     // Replace with your App ID from 8x8
  //const roomName = `${appId}/my-room`;     // Full room name with prefix
  const roomName = `${appId}/${sessionId}`;

  // Fetch the JWT token from the backend
  useEffect(() => {
    async function fetchToken() {
      try {
        const response = await axiosInstance.post('/jitsi/token', {
          userId: userId,
          roomName: sessionId    // Room name without prefix appId.(e.g., 'my-room')
        });
        setToken(response.data.token);
      } catch (error) {
        console.error('Error fetching token:', error);
      }
    }

    fetchToken();
  }, [sessionId, userId]);  //sessionId, userId

  // Alert if userId or sessionId is missing.
  if (!userId || !sessionId) {
    return <div>No userId or sessionId provided.</div>;
  }

  // Show loading state while token is being fetched
  if (!token) {
    return <div>Loading meeting...</div>;
  }

  // Render the Jitsi meeting
  return (
    <div style={{ height: '100vh' }}>
      <JitsiMeeting
        domain="8x8.vc"              // JaaS domain
        roomName={roomName}          // Full room name with prefix
        jwt={token}                  // JWT token from backend
        configOverwrite={{
          startWithAudioMuted: true, // Start with audio muted
          startWithVideoMuted: false, // Start with video muted
        }}
        getIFrameRef={(iframeRef) => {
          iframeRef.style.height = '100%';
          iframeRef.style.width = '100%';
        }}
      />
    </div>
  );
}

export default VideoCall;









//-----









// import React, { useState, useEffect } from 'react';
// import { JitsiMeeting } from '@jitsi/react-sdk';
// import { useLocation } from 'react-router-dom';
// import { axiosInstance } from '../lib/axiosInstance';

// function VideoCall() {
//   const { state } = useLocation();
//   const userId = state?.userId;
//   const sessionId = state?.sessionId;

//   const [token, setToken] = useState(null);

//   // Using only sessionId here (no prefix)
//   const roomName = sessionId; 

//   useEffect(() => {
//     async function fetchToken() {
//       try {
//         const response = await axiosInstance.post('/jitsi/token', {
//           userId: userId,
//           roomName: sessionId
//         });
//         setToken(response.data.token);
//       } catch (error) {
//         console.error('Error fetching token:', error);
//       }
//     }
//     fetchToken();
//   }, [sessionId, userId]);

//   if (!userId || !sessionId) {
//     return <div>No userId or sessionId provided.</div>;
//   }

//   if (!token) {
//     return <div>Loading meeting...</div>;
//   }

//   return (
//     <div style={{ height: '100vh' }}>
//       <JitsiMeeting
//         domain="8x8.vc"
//         roomName={roomName}
//         jwt={token}
//         configOverwrite={{
//           startWithAudioMuted: true,
//           startWithVideoMuted: false,
//         }}
//         getIFrameRef={(iframeRef) => {
//           iframeRef.style.height = '100%';
//         }}
//       />
//     </div>
//   );
// }

// export default VideoCall;